/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Page_NumberInputs */

const en_reading_class_page_number = /** @type {(inputs: Reading_Class_Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page numbers`)
};

const es_reading_class_page_number = /** @type {(inputs: Reading_Class_Page_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números de página`)
};

/**
* | output |
* | --- |
* | "Page numbers" |
*
* @param {Reading_Class_Page_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_page_number = /** @type {((inputs?: Reading_Class_Page_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Page_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_page_number(inputs)
	return en_reading_class_page_number(inputs)
});